/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../../base';
/**
 * SearchDisplayApi - axios parameter creator
 * @export
 */
export const SearchDisplayApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get search layout view by search term
         * @param {string} storeId The store identifier.
         * @param {string} searchTerm The search term.
         * @param {string} [responseFormat] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearchDisplayView: async (storeId: string, searchTerm: string, responseFormat?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getSearchDisplayView', 'storeId', storeId)
            // verify required parameter 'searchTerm' is not null or undefined
            assertParamExists('getSearchDisplayView', 'searchTerm', searchTerm)
            const localVarPath = `/store/{storeId}/searchdisplay/bySearchTerm`
                .replace(`{${"storeId"}}`, String(storeId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (responseFormat !== undefined) {
                localVarQueryParameter['responseFormat'] = responseFormat;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SearchDisplayApi - functional programming interface
 * @export
 */
export const SearchDisplayApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SearchDisplayApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get search layout view by search term
         * @param {string} storeId The store identifier.
         * @param {string} searchTerm The search term.
         * @param {string} [responseFormat] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSearchDisplayView(storeId: string, searchTerm: string, responseFormat?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSearchDisplayView(storeId, searchTerm, responseFormat, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SearchDisplayApi - factory interface
 * @export
 */
export const SearchDisplayApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SearchDisplayApiFp(configuration)
    return {
        /**
         * 
         * @summary Get search layout view by search term
         * @param {string} storeId The store identifier.
         * @param {string} searchTerm The search term.
         * @param {string} [responseFormat] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearchDisplayView(storeId: string, searchTerm: string, responseFormat?: string, options?: any): AxiosPromise<any> {
            return localVarFp.getSearchDisplayView(storeId, searchTerm, responseFormat, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SearchDisplayApi - object-oriented interface
 * @export
 * @class SearchDisplayApi
 * @extends {BaseAPI}
 */
export class SearchDisplayApi extends BaseAPI {
    /**
     * 
     * @summary Get search layout view by search term
     * @param {string} storeId The store identifier.
     * @param {string} searchTerm The search term.
     * @param {string} [responseFormat] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchDisplayApi
     */
    public getSearchDisplayView(storeId: string, searchTerm: string, responseFormat?: string, options?: any) {
        return SearchDisplayApiFp(this.configuration).getSearchDisplayView(storeId, searchTerm, responseFormat, options).then((request) => request(this.axios, this.basePath));
    }
}
